import { buildURL } from 'react-imgix';
import { TImgixUrlOptions } from './imgix.types';

export function getImgixUrl(source?: string, options?: TImgixUrlOptions) {
    return buildURL(source ? source : '', {
        auto: 'format',
        q: '70',
        ...options,
    });
}
